module.exports = __webpack_public_path__ + "static/media/curve2.a3610e23.svg";